import { render, staticRenderFns } from "./DetailPlayback.vue?vue&type=template&id=ec1cac22&scoped=true"
import script from "./DetailPlayback.vue?vue&type=script&lang=js"
export * from "./DetailPlayback.vue?vue&type=script&lang=js"
import style0 from "./DetailPlayback.vue?vue&type=style&index=0&id=ec1cac22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1cac22",
  null
  
)

export default component.exports